import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

// Menu
export interface Menu {
  path?: string;
  title?: string;
  type?: string;
  icon?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  megaMenu?: boolean;
  megaMenuType?: string; // small, medium, large
  bookmark?: boolean;
  children?: Menu[];
  routerLink?: string;
  fragment?: string;
  open?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class NavService {
  constructor() {}

  MENUITEMS: Menu[] = [
    // {
    //   title: 'Home',
    //   type: 'link',
    //   routerLink: '/home'
    // },
    {
      title: 'About Us',
      type: 'sub',
      routerLink: '/about-us',
      children: [
        {
          title: 'Mission',
          type: 'link',
          routerLink: '/about-us',
          fragment: 'mission'
        },
        {
          title: 'Vision',
          type: 'link',
          routerLink: '/about-us',
          fragment: 'vision'
        },
        {
          title: 'Approach',
          type: 'link',
          routerLink: '/about-us',
          fragment: 'approach'
        } ,
        {
          title: 'Who we serve',
          type: 'link',
          routerLink: '/about-us',
          fragment: 'who-we-serve'
        }
        ,
        {
          title: 'Leadership Team',
          type: 'link',
          routerLink: '/about-us',
          fragment: 'leadership'
        }
      ]
    },
    {
  title: 'Solutions',
  type: 'sub',
  routerLink: '/solution',
  children: [
    
    {
      title: 'Manufacturing & Systems Integration',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'manufacturing',
    
    },
    
    {
      title: 'UAVs',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'uavs',
      children: [
        { title: 'Short Range', type: 'link', routerLink: '/solution', fragment: 'short-range' },
        { title: 'Medium Range', type: 'link', routerLink: '/solution', fragment: 'medium-range' },
        { title: 'Long Range', type: 'link', routerLink: '/solution', fragment: 'long-range' }
      ]
    },
    {
      title: 'Border Security solutions',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'border-security',
      children: [
        { title: 'Operational Support', type: 'link', routerLink: '/solution', fragment: 'opst' },
        { title: 'Strategic Services', type: 'link', routerLink: '/solution', fragment: 'strategy' },
        { title: 'Detection Systems', type: 'link', routerLink: '/solution', fragment: 'detection' }
      ]
    },
     {
      title: 'Secure Transportation & Protective Services ',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'protective-services ',
      children: [
        { title: 'Overview', type: 'link', routerLink: '/solution', fragment: 'ov' },
        { title: ' Core Capabilities', type: 'link', routerLink: '/solution', fragment: 'core' },
        { title: ' Operational Presence', type: 'link', routerLink: '/solution', fragment: 'op' },
        { title: '  Armored Mobility', type: 'link', routerLink: '/solution', fragment: 'am' },
        { title: '  Compliance & Mission Governance', type: 'link', routerLink: '/solution', fragment: 'mg' },

      ]
    },
    //  {
    //   title: 'Manufacturing & Systems Integration',
    //   type: 'sub',
    //   routerLink: '/solution',
    //   fragment: 'manufacturing',
    
    // },
    {
      title: 'MRO Services',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'mro',
    
    }
    ,
     {
      title: 'Strategic Advisory & Operational Support ',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'sdo',
    
    }
    ,
    {
      title: 'Tactical and ISR Solutions',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'isr',
    
    }
    ,
    {
      title: 'Licensing',
      type: 'sub',
      routerLink: '/solution',
      fragment: 'licensing',
    
    }
  ]
},
// ,
//     {
//       title: 'Who we serve',
//       type: 'link',
//       routerLink: '/whoweserve'
//     },
    {
      title: 'Why Cyclops',
      type: 'sub',
      routerLink: '/whycyclops',
      children: [
        {
          title: 'Why choose us?',
          type: 'link',
          routerLink: '/whycyclops',
          fragment: 'whychoose'
        },
        {
          title: 'Capabilities & Advantages',
          type: 'link',
          routerLink: '/whycyclops',
          fragment: 'capability'
        },
        {
          title: 'Regional Market Strategy',
          type: 'link',
          routerLink: '/whycyclops',
          fragment: 'marketstrategy'
        }
      ]
    },
    {
      title: 'Contact Us',
      type: 'link',
      routerLink: '/contact'
    }
  ];

  // Observable
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
